import { render, staticRenderFns } from "./potonganAsuransi.vue?vue&type=template&id=24f69c4a"
import script from "./potonganAsuransi.vue?vue&type=script&lang=js"
export * from "./potonganAsuransi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports